module.exports = __webpack_public_path__ + "static/img/img17.4cf2e11.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/img17.png
// module id = nHmE
// module chunks = 1